<template>
	<v-btn text class="mt-2 error--text" @click="unlink(personId)">Desvincular</v-btn>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'PersonUnlinkButton',
	props: {
		personId: {
			type: String,
			required: true,
		},
	},

	methods: {
		async unlink(personId) {
			await this.unlinkSharedPerson(personId);
		},
		...mapActions({
			unlinkSharedPerson: 'Person/unlinkSharedPerson',
		}),
	},
};
</script>

<style scoped></style>
